import { Routes } from '@angular/router';

export const studentDashboardRoutes: Routes = [
  {
    path: '',
    redirectTo: 'profile',
    pathMatch: 'full',
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./profile/student-profile.component').then((m) => m.StudentProfileComponent),
  },
  {
    path: 'assignments',
    loadComponent: () =>
      import('./assignments/student-assignments.component').then((m) => m.StudentAssignmentsComponent),
  },
];
